import { PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import basicDetails from 'assets/userProfile/basicDetails.png';
import gameplay from 'assets/userProfile/gameplay.png';
import kyc from 'assets/userProfile/kyc.png';
import pastTickets from 'assets/userProfile/pastTickets.png';
import referrals from 'assets/userProfile/referrals.png';
import transactionHistory from 'assets/userProfile/transactionHistory.png';
import coupon from 'assets/userProfile/coupon.png';
// import tournament from 'assets/userProfile/tournament.png';
import paymentsStatus from 'assets/userProfile/paymentsStatus.png';
import lotteryWinnings from 'assets/miscellaneous/lottery.png';
import BasicDetails from './basicDetails';
import Gameplay from './gameplay';
import TransactionHistory from './transactionHistory';
import KycDetails from './kycDetails';
import PreviousTickets from './previousTickets';
import Referrals from './referrals';
import UserStats from './userStats';
import Coupons from './coupons';
// import Tournaments from './tournaments';
import PaymentsStatus from './paymentsStatus';
import LotteryWinningsDashboard from './lotteryWinnings';
import KycBankNameMismatch from './kycBankNameMismatch';

export const URL = {
	[USER_PROFILE_RESOURCES.basicDetails]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.basicDetails}`,
	[USER_PROFILE_RESOURCES.gameplay]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.gameplay}`,
	[USER_PROFILE_RESOURCES.transactionHistory]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.transactionHistory}`,
	[USER_PROFILE_RESOURCES.kycDetails]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.kycDetails}`,
	[USER_PROFILE_RESOURCES.previousTickets]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.previousTickets}`,
	[USER_PROFILE_RESOURCES.referrals]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.referrals}`,
	[USER_PROFILE_RESOURCES.userStats]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.userStats}`,
	[USER_PROFILE_RESOURCES.coupons]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.coupons}`,
	// [USER_PROFILE_RESOURCES.tournaments]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.tournaments}`,
	[USER_PROFILE_RESOURCES.paymentsStatus]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}`,
	[USER_PROFILE_RESOURCES.lotteryWinnings]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.lotteryWinnings}`,
	[USER_PROFILE_RESOURCES.kycBankNameMismatch]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.kycBankNameMismatch}`
};

export const LABEL = {
	[USER_PROFILE_RESOURCES.basicDetails]: 'Basic Details',
	[USER_PROFILE_RESOURCES.gameplay]: 'Gameplay',
	[USER_PROFILE_RESOURCES.transactionHistory]: 'Transaction History',
	[USER_PROFILE_RESOURCES.kycDetails]: 'KYC Details',
	[USER_PROFILE_RESOURCES.previousTickets]: 'Previous Tickets',
	[USER_PROFILE_RESOURCES.referrals]: 'Referrals',
	[USER_PROFILE_RESOURCES.userStats]: 'User Statistics',
	[USER_PROFILE_RESOURCES.coupons]: 'Coupons',
	// [USER_PROFILE_RESOURCES.tournaments]: 'Tournaments',
	[USER_PROFILE_RESOURCES.paymentsStatus]: 'Payments Status',
	[USER_PROFILE_RESOURCES.lotteryWinnings]: 'Lottery Winnings',
	[USER_PROFILE_RESOURCES.kycBankNameMismatch]: 'KYC Bank Name Mismatch'
};

export const COMPONENT = {
	[USER_PROFILE_RESOURCES.basicDetails]: BasicDetails,
	[USER_PROFILE_RESOURCES.gameplay]: Gameplay,
	[USER_PROFILE_RESOURCES.transactionHistory]: TransactionHistory,
	[USER_PROFILE_RESOURCES.kycDetails]: KycDetails,
	[USER_PROFILE_RESOURCES.previousTickets]: PreviousTickets,
	[USER_PROFILE_RESOURCES.referrals]: Referrals,
	[USER_PROFILE_RESOURCES.userStats]: UserStats,
	[USER_PROFILE_RESOURCES.coupons]: Coupons,
	// [USER_PROFILE_RESOURCES.tournaments]: Tournaments,
	[USER_PROFILE_RESOURCES.paymentsStatus]: PaymentsStatus,
	[USER_PROFILE_RESOURCES.lotteryWinnings]: LotteryWinningsDashboard,
	[USER_PROFILE_RESOURCES.kycBankNameMismatch]: KycBankNameMismatch
};

export const IMAGE_SOURCE = {
	[USER_PROFILE_RESOURCES.basicDetails]: basicDetails,
	[USER_PROFILE_RESOURCES.gameplay]: gameplay,
	[USER_PROFILE_RESOURCES.transactionHistory]: transactionHistory,
	[USER_PROFILE_RESOURCES.kycDetails]: kyc,
	[USER_PROFILE_RESOURCES.previousTickets]: pastTickets,
	[USER_PROFILE_RESOURCES.referrals]: referrals,
	[USER_PROFILE_RESOURCES.userStats]: basicDetails,
	[USER_PROFILE_RESOURCES.coupons]: coupon,
	// [USER_PROFILE_RESOURCES.tournaments]: tournament,
	[USER_PROFILE_RESOURCES.paymentsStatus]: paymentsStatus,
	[USER_PROFILE_RESOURCES.lotteryWinnings]: lotteryWinnings,
	// A KYC view, so it shares the KYC icon rather than adding an asset.
	[USER_PROFILE_RESOURCES.kycBankNameMismatch]: kyc
};
